import React from 'react'
import Search from './Search'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

class SearchContainer extends React.Component {
  // hepatitis_b
  // hib
  // diphtheria
  // tetanus
  // pertussis
  // poliomyelitis
  // pneumococcal_disease
  // rubella
  // uterine_cancer
  // rotavirus
  // meningococcal_infection
  // measles
  // mumps
  // varicella
  // influenza

  render () {
    const elements = [
      {
        name: 'Febre Amarela',
        type: 'pathology',
        docs: [
          {
            name: 'details',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/diseases/febre_amarela.pdf'
          }
        ]
      },
      {
        name: 'Hepatite A',
        type: 'pathology',
        docs: [
          {
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/diseases/hepatite_a.pdf',
            name: 'details'
          }
        ]
      },
      {
        name: 'Raiva',
        type: 'pathology',
        docs: [
          {
            name: 'details',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/diseases/raiva.pdf'
          }
        ]
      },
      {
        name: 'Rubéola',
        type: 'pathology',
        docs: [
          {
            name: 'details',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/diseases/rubeola.pdf'
          }
        ]
      },
      {
        name: 'Sarampo',
        type: 'pathology',
        docs: [
          {
            name: 'details',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/diseases/sarampo.pdf'
          }
        ]
      },
      // {
      //   name: 'Tosse Convulsa',
      //   type: 'pathology',
      //   docs: [
      //     {
      //       name: 'details',
      //       url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/diseases/tosse_convulsa.pdf'
      //     }
      //   ]
      // },
      // {
      //   name: 'Varicela',
      //   type: 'pathology',
      //   docs: [
      //     {
      //       name: 'details',
      //       url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/diseases/varicela.pdf'
      //     }
      //   ]
      // },
      {
        name: 'Zona (Herpes Zoster)',
        type: 'pathology',
        docs: [
          {
            name: 'details',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/diseases/zona_herpes_zoster.pdf'
          }
        ]
      },
      {
        name: 'Bexsero',
        type: 'vaccine',
        docs: [
          {
            name: 'epar',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/bexsero_epar.pdf'
          },
          {
            name: 'rcp',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/bexsero_rcp.pdf'
          }
        ]
      },
      {
        name: 'Cervarix',
        type: 'vaccine',
        docs: [
          {
            name: 'epar',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/cervarix_epar.pdf'
          },
          {
            name: 'rcp',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/cervarix_rcm.pdf'
          }
        ]
      },
      {
        name: 'Fluarix',
        type: 'vaccine',
        docs: [
          {
            name: 'fi',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/fluarix_gripe_fi.pdf'
          },
          {
            name: 'rcp',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/fluarix_rcm.pdf'
          }
        ]
      },
      {
        name: 'Gardasil',
        type: 'vaccine',
        docs: [
          {
            name: 'epar',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/gardasil_epar.pdf'
          }
        ]
      },
      {
        name: 'Hiberix',
        type: 'vaccine',
        docs: [
          {
            name: 'fi',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/hiberix_hemophilus_influenza_b_fi.pdf'
          },
          {
            name: 'rcp',
            url: 'https://cdn.kenetto.com/vaccinapp/files/portugal/hiberix_hemophilus_influenza_b_rcm.pdf'
          }
        ]
      }
    ]
    return <Search docs={elements} />
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({}, dispatch)
}

function mapStateToProps ({medicines}) {
  return {
    medicines
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchContainer)
